/**
 * `/workspace/:workspaceId/bantuan` — "Didampingi" (Phase 3, docs/nontech/CONTRACT.md).
 * Fixed-price human help: pick a package, pay through Pakasir, then follow the request until a
 * reviewer writes back what they fixed. Plain-language vocabulary only ("Minta ditinjau").
 */
import { createFileRoute, Link } from '@tanstack/react-router'
import { AppHeader } from '#/components/layout/app-header'
import { WorkspaceSimpleTabs } from '#/components/layout/workspace-simple-tabs'
import { DiscordCta } from '#/components/guided/discord-cta'
import { MyRequests } from '#/components/guided/my-requests'
import { RequestForm } from '#/components/guided/request-form'
import { useWorkspacePlans } from '#/lib/api'
import { useMyReviews } from '#/lib/api-guided'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/workspace/$workspaceId/bantuan')({
  head: () => ({ meta: [{ title: m.gd_page_title() }] }),
  component: GuidedPage,
})

function GuidedPage() {
  const { workspaceId } = Route.useParams()
  const { data: ws } = useWorkspacePlans(workspaceId)
  const { data } = useMyReviews()
  const plans = (ws?.plans ?? []).map((p) => ({ id: p.id, title: p.title }))
  const mine = data?.requests.filter((r) => plans.some((p) => p.id === r.planId)) ?? data?.requests

  return (
    <>
      <AppHeader
        showStats={false}
        compact
        left={
          <nav className="hidden items-center gap-1 truncate text-sm text-muted-foreground lg:flex">
            <span>/</span>
            <Link to="/workspace/$workspaceId" params={{ workspaceId }} className="truncate hover:text-foreground">
              {ws?.workspace.name ?? '…'}
            </Link>
            <span>/</span>
            <span className="truncate text-foreground">{m.gd_nav()}</span>
          </nav>
        }
        right={
          <div className="flex items-center gap-1">
            <WorkspaceSimpleTabs workspaceId={workspaceId} active="bantuan" />
            <DiscordCta url={data?.discordInviteUrl} compact />
          </div>
        }
      />
      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-6 sm:px-6">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div>
            <h1 className="font-heading text-2xl font-semibold">{m.gd_page_title()}</h1>
            <p className="mt-1 max-w-prose text-sm text-muted-foreground">{m.gd_page_desc()}</p>
          </div>
          <RequestForm plans={plans} packages={data?.packages} slaHours={data?.slaHours ?? 24} />
          <MyRequests items={mine} />
          <DiscordCta url={data?.discordInviteUrl} />
        </div>
      </main>
    </>
  )
}
